var _style, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ac2d2dff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,2c-0.2,0-0.4,0.1-0.5,0.2L9.9,3.5L8.3,3.2C7.8,3.1,7.5,3.4,7.4,3.8L7.1,5.6L5.4,6.4C5,6.6,4.9,7,5.1,7.4L5.9,9 l-0.8,1.6c-0.2,0.4,0,0.8,0.3,1l1.7,0.8l0.3,1.8c0.1,0.4,0.5,0.7,0.9,0.6l1.9-0.3l1.4,1.3c0.3,0.3,0.8,0.3,1.1,0l1.4-1.3l1.9,0.3 c0.4,0.1,0.8-0.2,0.9-0.6l0.3-1.8l1.7-0.8c0.4-0.2,0.5-0.6,0.3-1L18.1,9l0.8-1.6c0.2-0.4,0.1-0.8-0.3-1l-1.7-0.8l-0.3-1.8 c-0.1-0.4-0.5-0.7-0.9-0.6l-1.9,0.3l-1.4-1.3C12.3,2,12,2,11.8,2z M6.1,13.1L3,19.3l3.6-0.5L8.4,22l2.6-5.3l-0.2-0.2l-1-0.9 l-1.4,0.2c-0.9,0.1-1.8-0.5-2-1.4L6.1,13.1L6.1,13.1z M17.9,13.1l-0.3,1.3c-0.2,0.8-0.9,1.4-1.7,1.4h-0.2l-1.4-0.2l-1,0.9l-0.2,0.2 l2.6,5.3l1.8-3.1l3.6,0.5L17.9,13.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.11e3659c73238b40e04ac618df5c0cd4.svg";
export { ForwardRef as ReactComponent };